const initialQualityAssessmentsState = {
  qualityAssessments: undefined,
  totalCount: undefined,
  failureReasons: undefined,
  showMarkedChats: true,
  loading: false,
};

export default initialQualityAssessmentsState;
